import React, { useEffect } from 'react';
import { useAuth } from 'context/authContext';
import { useNavigate } from 'react-router-dom';
import { ClientLoginForm } from 'components';
import CUP from 'assets/images/cup.png';

export const ClientLoginPage = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth) {
      return navigate('/');
    }
  }, [auth, navigate]);

  return (
    !auth && (
      <>
        {/* DESKTOP VIEW LOGIN PAGE (shown on web > 900px) */}
        <div className="flex md:hidden relative justify-end h-full overflow-y-auto overflow-x-hidden bg-green-gradient min-h-screen">
          <div className="absolute z-10 top-0 bottom-0 left-[31%] -translate-x-1/2">
            <ClientLoginForm isMobile={false} />
          </div>
          <div className="fixed overflow-hidden w-full h-full pointer-events-none">
            <p className="text-[40px] text-green italic uppercase text-center font-bold absolute top-1/4 right-[13%] -translate-y-1/2">
              Keep going.
              <br /> You&apos;ve got this.
            </p>
            <img
              className="absolute w-[511px] right-[7%] top-2/3 -translate-y-1/2 z-10"
              src={CUP}
              alt="cup"
            />
            <span
              style={{ clipPath: 'ellipse(50vw 20vw)', WebkitClipPath: 'ellipse(50vw 20vw)' }}
              className="w-[90vw] h-[45vw] bg-orange-gradient rotate-[-215deg] absolute -bottom-[43%] right-[-16%] z-0 pointer-events-none"
            />
          </div>
        </div>

        {/* MOBILE VIEW LOGIN PAGE (shown on mobile <= 900px) */}
        <div className="hidden md:flex relative justify-center items-center h-screen max-h-screen overflow-hidden bg-green-gradient px-4 py-4">
          <div className="z-20 w-full max-w-[340px] flex justify-center items-center my-auto">
            <ClientLoginForm isMobile={true} />
          </div>
          <span
            style={{ clipPath: 'ellipse(60vw 30vw)', WebkitClipPath: 'ellipse(60vw 30vw)' }}
            className="w-[140vw] h-[70vw] bg-orange-gradient rotate-[-215deg] absolute -bottom-[15%] -right-[25%] z-0 pointer-events-none"
          />
        </div>
      </>
    )
  );
};
